import { link } from '../../../../../../../../../theme/images';
import { StubbornToolboxProperties } from '../../../../../../../../business/StubbornToolboxMapping';

export const toolbox: StubbornToolboxProperties = {
  name: 'breadcrumb',
  label: 'Breadcrumb',
  category: 'Navigation',
  image: link,
};
